import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-250ca414")

_pushScopeId("data-v-250ca414")
const _hoisted_1 = { class: "make-order-page" }
const _hoisted_2 = { class: "make-order-page-form" }
const _hoisted_3 = {
  key: 0,
  class: "make-order-page-btn"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { style: {"background-color":"#f5f5f5","padding":"40px 0","text-align":"center","font-weight":"600"} }, "是否取消会议", -1)
const _hoisted_5 = { class: "make-order-page-btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "会议详情",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, {
        readonly: _ctx.isEdit,
        ref: "meetingroom"
      }, {
        default: _withId(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withId(() => [
              _createVNode(_component_van_field, {
                readonly: "",
                rows: "3",
                modelValue: _ctx.siteName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.siteName = $event)),
                type: "text",
                name: "孵化站点",
                label: "孵化站点",
                placeholder: "请输入孵化站点",
                rules: [{ required: true, message: '请输入孵化站点' ,pattern:/^.{1,25}$/}],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEdit?null:_ctx.siteNamePicker = true))
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_popup, {
                show: _ctx.siteNamePicker,
                "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.siteNamePicker = $event)),
                round: "",
                position: "bottom"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_picker, {
                    "show-toolbar": "",
                    columns: _ctx.siteNameList,
                    onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.siteNamePicker = false)),
                    onConfirm: _ctx.siteNamOnConfirm
                  }, null, 8, ["columns", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                readonly: "",
                rows: "3",
                modelValue: _ctx.meetingRoomName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.meetingRoomName = $event)),
                type: "text",
                name: "会议地址",
                label: "会议地址",
                placeholder: "请输入会议地址",
                rules: [{ required: true, message: '请输入会议地址',pattern:/^.{1,20}$/ }],
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isEdit?null:_ctx.meetingRoomNamePicker = true))
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_popup, {
                show: _ctx.meetingRoomNamePicker,
                "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_ctx.meetingRoomNamePicker = $event)),
                round: "",
                position: "bottom"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_picker, {
                    "show-toolbar": "",
                    columns: _ctx.meetingRoomNameList,
                    onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.meetingRoomNamePicker = false)),
                    onConfirm: _ctx.meetingRoomNameOnConfirm
                  }, null, 8, ["columns", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.meetingName = $event)),
                type: "text",
                name: "会议名称",
                label: "会议名称",
                placeholder: "请输入会议名称",
                rules: [{ required: true, message: '请输入会议名称' ,pattern:/^.{1,20}$/ }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.bookingPersonName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.bookingPersonName = $event)),
                type: "text",
                name: "预定人",
                label: "预定人",
                placeholder: "请输入预定人",
                rules: [{ required: true, message: '请输入预定人' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.tel,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.tel = $event)),
                type: "text",
                name: "联系人手机",
                label: "联系人手机",
                placeholder: "请输入联系人手机",
                rules: [{pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '请输入联系人手机' }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingStartTime,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.meetingStartTime = $event)),
                "is-link": "",
                readonly: "",
                name: "datetimePicker",
                label: "开始时间",
                placeholder: "请选择开始时间",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isEdit?null:_ctx.openTimePicker(0)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: _ctx.showPicker,
                "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPicker = $event)),
                position: "bottom"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_datetime_picker, {
                    type: "datetime",
                    filter: _ctx.filter,
                    modelValue: _ctx.currentDatetime,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentDatetime = $event)),
                    onConfirm: _ctx.onConfirm,
                    onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showPicker = false))
                  }, null, 8, ["filter", "modelValue", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingEndTime,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.meetingEndTime = $event)),
                "is-link": "",
                type: "datetime",
                readonly: "",
                name: "datetimePicker",
                label: "结束时间",
                placeholder: "请选择结束时间",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isEdit?null:_ctx.openTimePicker(1)))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["readonly"])
    ]),
    (_ctx.isOneself)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", {
            class: "make-order-page-btn-cancel",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.cancelMeet && _ctx.cancelMeet(...args)))
          }, _toDisplayString(_ctx.isEdit?'取消会议':'取消'), 1),
          _createVNode("div", {
            class: "make-order-page-btn-edit",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.editMeet && _ctx.editMeet(...args)))
          }, _toDisplayString(_ctx.isEdit?'编辑会议':'保存'), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: _ctx.deleteMeet,
      "onUpdate:show": _cache[24] || (_cache[24] = ($event: any) => (_ctx.deleteMeet = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", {
            class: "make-order-page-btn-cancel",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "否"),
          _createVNode("div", {
            class: "make-order-page-btn-edit",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, "是")
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})